import React, { useState, useEffect } from "react";
import { FiArrowRight } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import buttonCircle from "../images/buttoncircle.png";
import trainersBackground from "../images/trainersbackground.png";

// Import all trainer images
const trainerImages = [
  require("../images/Trainers/1.png"),
  require("../images/Trainers/2.png"),
  require("../images/Trainers/3.png"),
  require("../images/Trainers/4.png"),
  require("../images/Trainers/5.png"),
  require("../images/Trainers/6.png"),
  require("../images/Trainers/7.png"),
  require("../images/Trainers/8.png"),
  require("../images/Trainers/9.png"),
  require("../images/Trainers/10.png"),
  require("../images/Trainers/11.png"),
  require("../images/Trainers/12.png"),
  require("../images/Trainers/13.png"),
  require("../images/Trainers/14.png")
];

const trainersData = trainerImages.map((image, index) => ({
  id: index + 1,
  image: image
}));

// Helper function to get responsive styles based on screen width
// New version — more fluid with 400px and 480px breakpoints
const getResponsiveStyles = (windowWidth = window.innerWidth) => {
  const width = windowWidth;

  if (width <= 400) {
    // Small mobile (400px and below)
    return {
      trainersSection: {
        flexDirection: 'column',
        padding: '0',
        textAlign: 'left',
        minHeight: 'auto',
        maxHeight: 'none',
        overflow: 'visible',
        background: '#363636',
      },
      trainersContent: {
        maxWidth: '100%',
        margin: '0',
        padding: '20px 15px',
        background: 'transparent',
        textAlign: 'left',
      },
      heading: {
        fontSize: '24px',
        lineHeight: 1.2,
        marginBottom: '12px',
        color: '#fff',
      },
      paragraph: {
        fontSize: '12px',
        marginBottom: '20px',
        lineHeight: 1.5,
        color: '#ccc',
      },
      trainersBtn: {
        fontSize: '11px',
        padding: '8px 16px',
        marginTop: '0',
        alignSelf: 'flex-start',
      },
      buttonIcon: {
        width: '16px',
        height: '16px',
      },
      carouselSection: {
        backgroundImage: `url(${trainersBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        padding: '30px 15px',
        width: '100%',
      },
      carouselContainer: {
        width: '100%',
        height: '200px',
        minHeight: '180px',
      },
      mainCard: {
        width: '280px',
        height: '300px',
      },
      secondaryCard: {
        width: '240px',
        height: '170px',
      },
      trainerName: {
        fontSize: '14px',
      },
      trainerTitle: {
        fontSize: '10px',
      },
    };
  }

  if (width <= 480) {
    // Mobile (401px to 480px)
    return {
      trainersSection: {
        flexDirection: 'column',
        padding: '0',
        textAlign: 'left',
        minHeight: 'auto',
        maxHeight: 'none',
        overflow: 'visible',
        background: '#363636',
      },
      trainersContent: {
        maxWidth: '100%',
        margin: '0',
        padding: '25px 20px',
        background: 'transparent',
        textAlign: 'left',
      },
      heading: {
        fontSize: '28px',
        lineHeight: 1.2,
        marginBottom: '15px',
        color: '#fff',
      },
      paragraph: {
        fontSize: '14px',
        marginBottom: '25px',
        lineHeight: 1.6,
        color: '#ccc',
      },
      trainersBtn: {
        fontSize: '12px',
        padding: '10px 18px',
        marginTop: '0',
        alignSelf: 'flex-start',
      },
      buttonIcon: {
        width: '18px',
        height: '18px',
      },
      carouselSection: {
        backgroundImage: `url(${trainersBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        padding: '40px 20px',
        width: '100%',
      },
      carouselContainer: {
        width: '100%',
        height: '220px',
        minHeight: '200px',
      },
      mainCard: {
        width: '320px',
        height: '320px',
      },
      secondaryCard: {
        width: '280px',
        height: '190px',
      },
      trainerName: {
        fontSize: '16px',
      },
      trainerTitle: {
        fontSize: '11px',
      },
    };
  }

  if (width <= 767) {
    // Medium Mobile (481px to 767px)
    return {
      trainersSection: {
        flexDirection: 'column',
        padding: '0',
        textAlign: 'left',
        minHeight: 'auto',
        maxHeight: 'none',
        overflow: 'visible',
        background: '#363636',
      },
      trainersContent: {
        maxWidth: '100%',
        margin: '0',
        padding: '35px 25px',
        background: 'transparent',
        textAlign: 'left',
      },
      heading: {
        fontSize: '32px',
        lineHeight: 1.2,
        marginBottom: '18px',
        color: '#fff',
      },
      paragraph: {
        fontSize: '16px',
        marginBottom: '30px',
        lineHeight: 1.6,
        color: '#ccc',
      },
      trainersBtn: {
        fontSize: '14px',
        padding: '12px 22px',
        marginTop: '0',
        alignSelf: 'flex-start',
      },
      buttonIcon: {
        width: '20px',
        height: '20px',
      },
      carouselSection: {
        backgroundImage: `url(${trainersBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        padding: '50px 25px',
        width: '100%',
      },
      carouselContainer: {
        width: '100%',
        height: '280px',
        minHeight: '260px',
      },
      mainCard: {
        width: '380px',
        height: '400px',
      },
      secondaryCard: {
        width: '320px',
        height: '240px',
      },
      trainerName: {
        fontSize: '18px',
      },
      trainerTitle: {
        fontSize: '13px',
      },
    };
  }

  if (width <= 991) {
    // Large Phones (768px to 991px)
    return {
      trainersSection: {
        backgroundImage: `url(${trainersBackground})`,
        flexDirection: 'column',
        padding: '40px 30px',
        textAlign: 'left',
        minHeight: 'auto',
        maxHeight: 'none',
        overflow: 'visible',
        background: '#363636',
      },
      trainersContent: {
        maxWidth: '100%',
        margin: '0',
        padding: '40px 30px',
        background: 'transparent',
        textAlign: 'left',
      },
      heading: {
        fontSize: '36px',
        lineHeight: 1.2,
        marginBottom: '20px',
        color: '#fff',
      },
      paragraph: {
        fontSize: '18px',
        marginBottom: '35px',
        lineHeight: 1.6,
        color: '#ccc',
      },
      trainersBtn: {
        fontSize: '16px',
        padding: '14px 24px',
        marginTop: '0',
        alignSelf: 'flex-start',
      },
      buttonIcon: {
        width: '22px',
        height: '22px',
      },
      carouselSection: {
        padding: '60px 30px',
        width: '100%',
      },
      carouselContainer: {
        width: '100%',
        height: '320px',
        minHeight: '300px',
      },
      mainCard: {
        width: '420px',
        height: '450px',
      },
      secondaryCard: {
        width: '360px',
        height: '280px',
      },
      trainerName: {
        fontSize: '20px',
      },
      trainerTitle: {
        fontSize: '14px',
      },
    };
  }

  if (width >= 768 && width <= 1024) {
    // Tablets (768px to 1024px)
    return {
      trainersSection: {
        backgroundImage: `url(${trainersBackground})`,
        flexDirection: 'column',
        padding: '50px 40px',
        textAlign: 'left',
        minHeight: 'auto',
        maxHeight: 'none',
        overflow: 'visible',
        background: '#363636',
      },
      trainersContent: {
        maxWidth: '100%',
        margin: '0',
        padding: '45px 35px',
        background: 'transparent',
        textAlign: 'left',
      },
      heading: {
        fontSize: '40px',
        lineHeight: 1.2,
        marginBottom: '22px',
        color: '#fff',
      },
      paragraph: {
        fontSize: '20px',
        marginBottom: '40px',
        lineHeight: 1.6,
        color: '#ccc',
      },
      trainersBtn: {
        fontSize: '18px',
        padding: '16px 26px',
        marginTop: '0',
        alignSelf: 'flex-start',
      },
      buttonIcon: {
        width: '24px',
        height: '24px',
      },
      carouselSection: {
        padding: '70px 35px',
        width: '100%',
      },
      carouselContainer: {
        width: '100%',
        height: '380px',
        minHeight: '360px',
      },
      mainCard: {
        width: '480px',
        height: '520px',
      },
      secondaryCard: {
        width: '400px',
        height: '320px',
      },
      trainerName: {
        fontSize: '22px',
      },
      trainerTitle: {
        fontSize: '16px',
      },
    };
  }

  if (width < 1024) {
    // Legacy tablets (should not be reached due to above condition)
    return {
      trainersSection: {
        backgroundImage: `url(${trainersBackground})`,
        flexDirection: 'column',
        padding: '30px 20px',
        textAlign: 'center',
        minHeight: '450px',
        maxHeight: '100vh',
        overflow: 'hidden',
      },
      trainersContent: {
        maxWidth: '80%',
        margin: '0 auto 25px auto', // Center horizontally
        padding: '0 20px', // Add horizontal padding
      },
      heading: {
        fontSize: '32px',
        lineHeight: 1.1,
      },
      paragraph: {
        fontSize: '14px',
        marginBottom: '12px',
      },
      trainersBtn: {
        fontSize: '13px',
        padding: '7px 14px',
      },
      buttonIcon: {
        width: '20px',
        height: '20px',
      },
      carouselContainer: {
        width: '70%',
        height: '250px',
      },
      mainCard: {
        width: '50%',
        height: '280px',
      },
      secondaryCard: {
        width: '40%',
        height: '225px',
      },
      trainerName: {
        fontSize: '16px',
      },
      trainerTitle: {
        fontSize: '12px',
      },
    };
  }

  if (width < 1920) {
    // Desktop
    return {
      trainersSection: {
        backgroundImage: `url(${trainersBackground})`,
        flexDirection: 'row',
        padding: '40px',
        minHeight: '100vh',
        maxHeight: '100vh',
        overflow: 'hidden',
        justifyContent: 'center', // Center content horizontally
        alignItems: 'center',
        backgroundSize: 'cover',
      },
      trainersContent: {
        maxWidth: '480px', // Set a fixed maxWidth for better centering
        margin: '0 auto 0 0', // Align left on desktop
        padding: '0 40px', // Reasonable horizontal padding
        textAlign: 'left', // Left align on desktop
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
      heading: {
        fontSize: '60px',
      },
      paragraph: {
        fontSize: '1.2rem',
        marginBottom: '12px',
      },
      trainersBtn: {
        marginTop: "35px",
        fontSize: '20px',
        padding: '10px 20px',
      },
      buttonIcon: {
        width: '20px',
        height: '20px',
      },
      carouselContainer: {
        width: '520px',
        height: '460px',
      },
      mainCard: {
        width: '500px',
        height: '550px',
      },
      secondaryCard: {
        width: '400px',
        height: '420px',
      },
      trainerName: {
        fontSize: '18px',
      },
      trainerTitle: {
        fontSize: '12px',
      },
    };
  }

  // TV / 4K screens
  return {
    trainersSection: {
      flexDirection: 'row',
      padding: '60px 40px',
      minHeight: '600px',
      maxHeight: '100vh',
      overflow: 'hidden',
      justifyContent: 'center', // Center content horizontally
    },
    trainersContent: {
      maxWidth: '600px', // Larger maxWidth for big screens
      margin: '0 auto 0 0', // Center left
      padding: '0 40px 0 0', // Add right padding
      textAlign: 'left', // Left align for readability
    },
    heading: {
      fontSize: '48px',
    },
    paragraph: {
      fontSize: '16px',
      marginBottom: '16px',
    },
    trainersBtn: {
      fontSize: '16px',
      padding: '10px 20px',
    },
    buttonIcon: {
      width: '24px',
      height: '24px',
    },
    carouselContainer: {
      width: '400px',
      height: '320px',
    },
    mainCard: {
      width: '430px',
      height: '550px',
    },
    secondaryCard: {
      width: '390px',
      height: '490px',
    },
    trainerName: {
      fontSize: '22px',
    },
    trainerTitle: {
      fontSize: '14px',
    },
  };
};


const getBaseStyles = () => ({
  trainersSection: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    background: '#111', // Dark background for the whole section
    color: '#fff',
    position: 'relative',
    overflow: 'visible',
    minHeight: 'auto',
    maxHeight: 'none',
    padding: '0',
  },
  trainersContent: {
    flex: 'none',
    zIndex: 2,
    textAlign: 'left',
    margin: '0',
    padding: '0',
    background: 'transparent', // No background for content area
  },
  heading: {
    marginBottom: '20px',
    fontWeight: 'bold',
  },
  headingSpan: {
    color: '#39d353',
  },
  paragraph: {
    color: '#ccc',
    lineHeight: 1.6,
  },
  trainersBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#333',
    border: '2px solid #fff',
    borderRadius: '50px',
    color: '#fff',
    cursor: 'pointer',
    boxShadow: '4px 4px 0 #000',
    margin: '0',
    transition: 'all 0.3s ease',
    fontWeight: 'bold',
  },
  buttonText: {
    marginRight: '20px',
  },
  buttonIcon: {
    borderRadius: '50%',
  },
  buttonIconImg: {
    width: '100%',
    height: '100%',
    borderRadius: '50%',
  },
  arrowIcon: {
    marginLeft: '8px',
  },
  trainersCards: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    overflow: 'visible',
    flexDirection: 'column',
    minHeight: '400px',
    paddingTop: '60px',
  },
  carouselSection: {
    // Background will be applied via responsive styles for mobile
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  carouselContainer: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  trainerCard: {
    background: '#222',
    borderRadius: '20px',
    overflow: 'hidden',
    position: 'absolute',
    boxShadow: '0 20px 40px rgba(0, 0, 0, 0.5)',
    transition: 'all 0.8s cubic-bezier(0.25, 0.8, 0.25, 1)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  },
  mainCard: {
    zIndex: 2,
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%) scale(1)',
    opacity: 1,
  },
  secondaryCard: {
    zIndex: 1,
    left: '50%',
    top: '50%',
    transform: 'translate(-20%, -50%) scale(0.9)',
    opacity: 0.7,
  },
  trainerImg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  trainerInfo: {
    position: 'absolute',
    bottom: '0',
    left: '0',
    right: '0',
    background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
    padding: '40px 20px 20px',
    color: 'white',
    textAlign: 'left',
  },
  trainerName: {
    margin: '0 0 5px 0',
    fontWeight: 'bold',
    color: 'white',
    textAlign: 'left',
  },
  trainerTitle: {
    margin: 0,
    color: '#ccc',
    opacity: 0.9,
    textAlign: 'left',
  },
  progressBar: {
    position: 'relative',
    marginTop: '100px', // Keep as is
    width: '80px',
    height: '6px',
    background: '#333',
    borderRadius: '3px',
    overflow: 'hidden',
    alignSelf: 'center',
    zIndex: 3, // Ensure progress bar is above cards
    display: 'flex', // For segment layout
    flexDirection: 'row',
    gap: '2px', // Small gap between segments
  },
  progressSegment: {
    flex: 1,
    height: '100%',
    borderRadius: '3px',
    background: '#555', // Default color
    transition: 'background 0.3s',
  },
  progressSegmentActive: {
    background: '#39d353', // Active color
  },
});

export default function OurTrainers() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % trainersData.length);
    }, 3000); // Change every 3 seconds

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Merge base styles with responsive styles
  const mergeStyles = (baseStyles, responsiveStyles) => {
    const merged = {};
    Object.keys(baseStyles).forEach(key => {
      merged[key] = {
        ...baseStyles[key],
        ...(responsiveStyles[key] || {})
      };
    });
    // Also include any responsive-only styles
    Object.keys(responsiveStyles).forEach(key => {
      if (!merged[key]) {
        merged[key] = responsiveStyles[key];
      }
    });
    return merged;
  };

  const baseStyles = getBaseStyles();
  const responsiveStyles = getResponsiveStyles(windowWidth);
  const styles = mergeStyles(baseStyles, responsiveStyles);

  const getCardStyle = (index) => {
    const isMain = index === currentIndex;
    const isSecondary = index === (currentIndex + 1) % trainersData.length;
    const isSmallMobile = windowWidth <= 400;
    const isMobile = windowWidth <= 480;
    const isMediumMobile = windowWidth <= 767;
    const isLargePhone = windowWidth <= 991;
    const isTablet = windowWidth >= 768 && windowWidth <= 1024;
    const isLegacyTablet = windowWidth < 1024 && windowWidth > 991;

    if (isMain) {
      return {
        ...styles.trainerCard,
        ...styles.mainCard,
        width: responsiveStyles.mainCard?.width || styles.mainCard.width,
        height: responsiveStyles.mainCard?.height || styles.mainCard.height,
        transform: (isSmallMobile || isMobile || isMediumMobile || isLargePhone || isTablet) ? 'translate(-50%, -50%) scale(1)' : 'translate(-50%, -50%) scale(1)',
      };
    } else if (isSecondary) {
      return {
        ...styles.trainerCard,
        ...styles.secondaryCard,
        width: responsiveStyles.secondaryCard?.width || styles.secondaryCard.width,
        height: responsiveStyles.secondaryCard?.height || styles.secondaryCard.height,
        transform: (isSmallMobile || isMobile || isMediumMobile || isLargePhone || isTablet) ? 'translate(-50%, -50%) scale(0.8)' : isLegacyTablet ? 'translate(-50%, -50%) scale(0.8)' : 'translate(-20%, -50%) scale(0.9)',
      };
    } else {
      return {
        ...styles.trainerCard,
        ...styles.secondaryCard,
        opacity: 0,
        transform: (isSmallMobile || isMobile || isMediumMobile || isLargePhone || isTablet) ? 'translate(-50%, -50%) scale(0.6)' : isLegacyTablet ? 'translate(-50%, -50%) scale(0.6)' : 'translate(-20%, -50%) scale(0.8)',
        zIndex: 0,
        width: responsiveStyles.secondaryCard?.width || styles.secondaryCard.width,
        height: responsiveStyles.secondaryCard?.height || styles.secondaryCard.height,
      };
    }
  };

  return (
    <section style={styles.trainersSection}>
      {/* Content Section (No Background) */}
      <div style={styles.trainersContent}>
        <h2 style={{
          ...styles.heading,
          fontSize: responsiveStyles.heading?.fontSize || styles.heading.fontSize,
          color: responsiveStyles.heading?.color || styles.heading.color,
        }}>
          Our Trainers
        </h2>
        <p style={{
          ...styles.paragraph,
          fontSize: responsiveStyles.paragraph?.fontSize || styles.paragraph.fontSize,
          color: responsiveStyles.paragraph?.color || styles.paragraph.color,
        }}>
          Meet our expert trainers who are dedicated to helping you achieve your fitness goals. With years of experience and specialized knowledge, they're here to guide you every step of the way.
        </p>
        <button
          style={{
            ...styles.trainersBtn,
            fontSize: responsiveStyles.trainersBtn?.fontSize || styles.trainersBtn.fontSize,
            padding: responsiveStyles.trainersBtn?.padding || styles.trainersBtn.padding,
          }}
          onClick={() => navigate('/trainers')}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#555';
            e.target.style.transform = 'translateY(-1px)';
            e.target.style.boxShadow = '2px 2px 0 #000';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#333';
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '4px 4px 0 #000';
          }}
        >
          <span style={styles.buttonText}>More Trainers</span>
          <span style={{
            ...styles.buttonIcon,
            width: responsiveStyles.buttonIcon?.width || styles.buttonIcon.width,
            height: responsiveStyles.buttonIcon?.height || styles.buttonIcon.height,
          }}>
            <img src={buttonCircle} alt="Button Circle" style={styles.buttonIconImg} />
          </span>
        </button>
      </div>

      {/* Carousel Section (With Background for Mobile) */}
      <div style={{
        ...styles.carouselSection,
        ...(responsiveStyles.carouselSection || {}),
      }}>
        <div style={styles.trainersCards}>
          <div style={{
            ...styles.carouselContainer,
            width: responsiveStyles.carouselContainer?.width || styles.carouselContainer.width,
            height: responsiveStyles.carouselContainer?.height || styles.carouselContainer.height,
          }}>
            {trainersData.map((trainer, index) => (
              <div
                key={trainer.id}
                style={{
                  ...getCardStyle(index),
                  backgroundImage: `url(${trainer.image})`,
                }}
              />
            ))}
          </div>

          <div style={styles.progressBar}>
            {trainersData.map((_, idx) => (
              <div
                key={idx}
                style={{
                  ...styles.progressSegment,
                  ...(currentIndex === idx ? styles.progressSegmentActive : {}),
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
